import { createUseStyles } from 'react-jss'

export const useStyle = createUseStyles({
  fromDate: {
    marginLeft: 4
  }
})
